// extracted by mini-css-extract-plugin
export default {"project-stacks":"badges_project-stacks__6gNLb","project-stack-badge":"badges_project-stack-badge__4SYL7"};